/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types'
import React from 'react'

const ButtonWithLoader = ({ children, isLoading, spinnerClassName, ...props }) => {
  if (isLoading) {
    return (
      <div data-uk-spinner="" className={spinnerClassName} />
    )
  }
  return (
    <button
      {...props}
      type="button"
      disabled={props.disabled || isLoading}
    >
      {children}
    </button>
  )
}

ButtonWithLoader.propTypes = {
  isLoading: PropTypes.bool,
}
ButtonWithLoader.defaultProps = {
  isLoading: false,
}

export default ButtonWithLoader
